@if (mode() !== "month") {
    <div
        [ngClass]="
            mode() === 'month'
                ? 'overflow-x-auto'
                : 'flex-1 overflow-x-auto overflow-y-auto'
        "
        class="theme-border timeline-container"
    >
        <ng-container *ngTemplateOutlet="timeSection" />

        <!-- 종일 이벤트를 표시할 섹션 -->
        <ng-container *ngTemplateOutlet="allDaySection" />

        <!-- 시간별 이벤트를 표시할 섹션 -->
        <ng-container *ngTemplateOutlet="timelineSection" />
    </div>

    <ng-template #timeSection>
        <div class="day-wrapper">
            <div class="w-[8rem]"></div>
            @for (day of renderDays(); track day.format("DD")) {
                <app-timeline-day
                    [attr.data-day]="day.format('DD')"
                    class="day-item"
                    [day]="day"
                />
            }
        </div>
    </ng-template>
    <ng-template #allDaySection>
        <app-all-day-timeline [days]="renderDays() || []" />
    </ng-template>

    <ng-template #timelineSection>
        <!-- 새벽 시간 접기/펼치기 버튼 -->
        <button
            (click)="isEarlyMorningExpanded.set(!isEarlyMorningExpanded())"
            class="flex items-center justify-center gap-2 py-2 px-4 theme-border border-b bg-gray-50/50 hover:bg-gray-100 transition-colors group cursor-pointer"
        >
            <app-icon
                [name]="
                    isEarlyMorningExpanded()
                        ? 'solar:alt-arrow-up-bold-duotone'
                        : 'solar:alt-arrow-down-bold-duotone'
                "
                class="text-gray-400 group-hover:text-primary transition-colors"
            />
            <p
                class="font-medium text-gray-400 group-hover:text-primary transition-colors"
            >
                오전 시간(00시 ~ 07시)
                {{ isEarlyMorningExpanded() ? "접기" : "펼치기" }}
            </p>
        </button>

        @for (time of times; track time) {
            @if (!isEarlyMorning(time) || isEarlyMorningExpanded()) {
                <div class="flex flex-col flex-1 w-full min-w-max">
                    <app-timeline
                        [time]="time"
                        [days]="renderDays() || []"
                        [last]="$last"
                        [slots]="slots()"
                    />
                </div>
            }
        }
    </ng-template>
}
